import {
  Language,
  CookiePreference,
  AvailableLanguageCodesEnum
} from '@ui/shared/model';
import {
  AppAction,
  SET_AVAILABLE_LANGUAGES,
  SET_COOKIES_PREFERENCE_SUCCESS,
  SET_CURRENT_LOCALE,
  SET_DEFAULT_LANGUAGE_CODE,
  SET_PERFORMANCE_WARNING_CONFIRMATION
} from './app.actions';

export interface AppState {
  currentLocale: AvailableLanguageCodesEnum;
  availableLanguages: Language[];
  defaultLanguageCode: AvailableLanguageCodesEnum;
  cookiesPreference: CookiePreference;
  performanceWarningConfirmed: boolean;
}

export const initialState: AppState = {
  currentLocale: null,
  availableLanguages: [],
  defaultLanguageCode: null,
  cookiesPreference: null,
  performanceWarningConfirmed: false
};

export function reducer(
  state: AppState = initialState,
  action: AppAction
): AppState {
  switch (action.type) {
    case SET_CURRENT_LOCALE: {
      return {
        ...state,
        currentLocale: action.locale
      };
    }

    case SET_AVAILABLE_LANGUAGES: {
      return {
        ...state,
        availableLanguages: action.languages
      };
    }

    case SET_DEFAULT_LANGUAGE_CODE: {
      return {
        ...state,
        defaultLanguageCode: action.languageCode
      };
    }

    case SET_COOKIES_PREFERENCE_SUCCESS: {
      return {
        ...state,
        cookiesPreference: action.cookiePreference
      };
    }

    case SET_PERFORMANCE_WARNING_CONFIRMATION: {
      return {
        ...state,
        performanceWarningConfirmed: action.confirmation
      };
    }

    default: {
      return state;
    }
  }
}

export const getCurrentLocale = (state: AppState) => state.currentLocale;
export const getAvailableLanguages = (state: AppState) =>
  state.availableLanguages;
export const getDefaultLanguageCode = (state: AppState) =>
  state.defaultLanguageCode;
export const getCookiesPreference = (state: AppState) =>
  state.cookiesPreference;
export const getPerformanceWarningConfirmed = (state: AppState) =>
  state.performanceWarningConfirmed;
